import React from "react";
import { TogglePremiumTemplate } from "themes/application/home/components";

function TogglePremium(props) {
    return <TogglePremiumTemplate {...props} />;
}

export default TogglePremium;
